import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const DisplayIcon = forwardRef<SVGSVGElement, IconProps>(function DisplayIcon(
  { color = '', height = 12, width = 12, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.74998 15.0785C9.50687 15.0819 9.25693 15.0835 9 15.0835C8.74307 15.0835 8.49313 15.0819 8.25002 15.0785C1.48027 14.9853 0 13.537 0 7.54172C0 1.33111 1.5885 0 9 0C16.4115 0 18 1.33111 18 7.54172C18 13.537 16.5197 14.9853 9.74998 15.0785ZM2.76001 12.6984C1.94781 12.0178 1.5 10.6901 1.5 7.54172C1.5 4.39335 1.94781 3.06566 2.76001 2.38507C3.15555 2.05361 3.75853 1.77453 4.7803 1.58425C5.81591 1.39138 7.17988 1.30807 9 1.30807C10.8201 1.30807 12.1841 1.39138 13.2197 1.58425C14.2415 1.77453 14.8444 2.05361 15.24 2.38507C16.0522 3.06566 16.5 4.39335 16.5 7.54172C16.5 10.6901 16.0522 12.0178 15.24 12.6984C14.8444 13.0298 14.2415 13.3089 13.2197 13.4992C12.1841 13.6921 10.8201 13.7754 9 13.7754C7.17988 13.7754 5.81591 13.6921 4.7803 13.4992C3.75853 13.3089 3.15555 13.0298 2.76001 12.6984Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 14.4294C9.41421 14.4294 9.75 14.7222 9.75 15.0834V16.6919H12C12.4142 16.6919 12.75 16.9848 12.75 17.346C12.75 17.7072 12.4142 18 12 18H6C5.58579 18 5.25 17.7072 5.25 17.346C5.25 16.9848 5.58579 16.6919 6 16.6919H8.25V15.0834C8.25 14.7222 8.58579 14.4294 9 14.4294Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
